module.exports = __webpack_public_path__ + "img/overview8.ad6ea4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/overview8.jpg
// module id = p30j
// module chunks = 0